import React from 'react';
import { Scale, Shield, User, Server, Copyright, Cookie } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const MentionsLegales = () => {
  const scrollRef1 = useScrollAnimation();
  const scrollRef2 = useScrollAnimation();
  const scrollRef3 = useScrollAnimation();

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black"></div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div 
            ref={scrollRef1 as React.RefObject<HTMLDivElement>}
            className="scroll-reveal text-center mb-16"
          >
            <h1 className="text-5xl md:text-7xl font-light heading-modern mb-6">
              Mentions <span className="heading-accent">Légales</span>
            </h1>
            <div className="w-32 h-px bg-gradient-to-r from-transparent via-yellow-400 to-transparent mx-auto mb-8"></div>
            <p className="text-xl text-white/70 font-light max-w-4xl mx-auto leading-relaxed">
              Informations légales et conditions d'utilisation du site buchta-musique.com
            </p>
          </div>
        </div>
      </section>

      {/* Contenu des mentions légales */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto space-y-12">
            
            {/* Éditeur du site */}
            <div 
              ref={scrollRef2 as React.RefObject<HTMLDivElement>}
              className="scroll-reveal glass-card rounded-3xl p-8"
            >
              <div className="flex items-center space-x-4 mb-6">
                <User className="h-8 w-8 text-yellow-400" />
                <h2 className="text-2xl font-semibold text-white">Éditeur du site</h2>
              </div>
              
              <div className="text-white/80 space-y-4">
                <p>Le site buchta-musique.com est édité par :</p>
                <div className="bg-white/5 rounded-2xl p-6 space-y-2">
                  <p><strong>Monsieur Jean BUCHTA</strong></p>
                  <p>Entreprise individuelle (affaire personnelle)</p>
                  <p><strong>SIREN :</strong> 311 631 139</p>
                  <p><strong>SIRET :</strong> 311 631 139 00079</p>
                  <p><strong>Numéro de TVA intracommunautaire :</strong> FR 57 311 631 139</p>
                  <p><strong>Siège social :</strong> 122 Rue de l'Île Napoléon, 68170 Rixheim, France</p>
                  <p><strong>Activité principale (NAF / APE) :</strong> 9529Z – Réparation d'autres biens personnels et domestiques</p>
                  <p><strong>Date de création :</strong> 29 mai 2017</p>
                  <p><strong>Email :</strong> musique.buchta@gmail.com</p>
                  <p><strong>Téléphone :</strong> 03 89 54 20 03</p>
                  <p><strong>Directeur de la publication :</strong> Jean BUCHTA</p>
                </div>
              </div>
            </div>

            {/* Hébergement */}
            <div className="scroll-reveal glass-card rounded-3xl p-8">
              <div className="flex items-center space-x-4 mb-6">
                <Server className="h-8 w-8 text-yellow-400" />
                <h2 className="text-2xl font-semibold text-white">Hébergement du site</h2>
              </div>
              
              <div className="text-white/80">
                <p className="mb-4">Le site buchta-musique.com est hébergé par :</p>
                <div className="bg-white/5 rounded-2xl p-6">
                  <p className="text-white/60">Informations d'hébergement à compléter</p>
                </div>
              </div>
            </div>

            {/* Propriété intellectuelle */}
            <div className="scroll-reveal glass-card rounded-3xl p-8">
              <div className="flex items-center space-x-4 mb-6">
                <Copyright className="h-8 w-8 text-yellow-400" />
                <h2 className="text-2xl font-semibold text-white">Propriété intellectuelle</h2>
              </div>
              
              <div className="text-white/80 space-y-4">
                <p>L'ensemble du contenu présent sur ce site (textes, images, sons, vidéos, graphismes, logo, icônes, etc.) est la propriété exclusive de Jean BUCHTA, sauf mention contraire.</p>
                <p>Toute reproduction, distribution, modification, adaptation, retransmission ou publication, même partielle, est strictement interdite sans l'accord écrit de Jean BUCHTA.</p>
              </div>
            </div>

            {/* Données personnelles */}
            <div 
              ref={scrollRef3 as React.RefObject<HTMLDivElement>}
              className="scroll-reveal glass-card rounded-3xl p-8"
            >
              <div className="flex items-center space-x-4 mb-6">
                <Shield className="h-8 w-8 text-yellow-400" />
                <h2 className="text-2xl font-semibold text-white">Données personnelles</h2>
              </div>
              
              <div className="text-white/80 space-y-4">
                <p>Ce site peut être amené à collecter des données personnelles (formulaire de contact, newsletter, etc.).</p>
                <p>Les informations collectées sont uniquement destinées à l'usage de Jean BUCHTA et ne seront jamais transmises à des tiers sans consentement.</p>
                <p>Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles.</p>
                <p>Vous pouvez exercer ce droit en écrivant à : musique.buchta@gmail.com</p>
              </div>
            </div>

            {/* Cookies */}
            <div className="scroll-reveal glass-card rounded-3xl p-8">
              <div className="flex items-center space-x-4 mb-6">
                <Cookie className="h-8 w-8 text-yellow-400" />
                <h2 className="text-2xl font-semibold text-white">Cookies</h2>
              </div>
              
              <div className="text-white/80 space-y-4">
                <p>Le site buchta-musique.com peut utiliser des cookies à des fins de mesure d'audience et d'amélioration de l'expérience utilisateur.</p>
                <p>Vous pouvez refuser le dépôt des cookies à tout moment via les paramètres de votre navigateur.</p>
              </div>
            </div>

            {/* Responsabilité */}
            <div className="scroll-reveal glass-card rounded-3xl p-8">
              <div className="flex items-center space-x-4 mb-6">
                <Scale className="h-8 w-8 text-yellow-400" />
                <h2 className="text-2xl font-semibold text-white">Responsabilité</h2>
              </div>
              
              <div className="text-white/80 space-y-4">
                <p>Jean BUCHTA s'efforce d'assurer au mieux l'exactitude et la mise à jour des informations diffusées sur le site, mais ne peut garantir l'absence d'erreurs ou d'omissions.</p>
                <p>L'éditeur du site ne saurait être tenu responsable :</p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>des interruptions ou dysfonctionnements du site,</li>
                  <li>des dommages directs ou indirects liés à l'utilisation du site.</li>
                </ul>
              </div>
            </div>

            {/* Droit applicable */}
            <div className="scroll-reveal glass-card rounded-3xl p-8">
              <div className="flex items-center space-x-4 mb-6">
                <Scale className="h-8 w-8 text-yellow-400" />
                <h2 className="text-2xl font-semibold text-white">Droit applicable</h2>
              </div>
              
              <div className="text-white/80 space-y-4">
                <p>Les présentes mentions légales sont régies par le droit français.</p>
                <p>En cas de litige, la juridiction compétente sera celle du ressort du tribunal de Mulhouse (68).</p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default MentionsLegales;